const firebase = {
  apiKey: "AIzaSyCLpLuWKToIEUu5oSv_NpmsEYtEkZhd81c",
  authDomain: "pmc-2018-demo.firebaseapp.com",
  databaseURL: "https://pmc-2018-demo.firebaseio.com",
  projectId: "pmc-2018-demo",
  storageBucket: "pmc-2018-demo.appspot.com",
  messagingSenderId: "346886877359"
}

export default {
  firebase
};



// WEBPACK FOOTER //
// ./src/config.js